import { UUID, RecordingStatusLiterals, NameOfRecordingsTableIndexForStatus } from "./DatabaseTypes";
import { requireEvidenceDatabase } from "./getDatabase";

export class DbRecordingsTableReader {

	static async getAllRecordings() {
		const db = await requireEvidenceDatabase();
		return await db.getAll("recordings") ?? [];
	}

	static getRecordingsInProgress = async () => {
		const db = await requireEvidenceDatabase();
		return db.getAllFromIndex("recordings", NameOfRecordingsTableIndexForStatus, IDBKeyRange.only(RecordingStatusLiterals.recording));
	}
	
	static getRecording = async (recordingUuid: UUID) => {
		const db = await requireEvidenceDatabase();
		return db.get("recordings", recordingUuid);
	}

}

